import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import stripePromise from "../payments/stripeConfig";
import { sendPageView } from "../utils/ga4";
import { sendMetaPageView } from "../utils/metaPixel";

// 👇 tus imports normales
import Dashboard from "../componentsdash/Dashboard";
import DashboardContent from "../componentsdash/Content/DashboardContent";
import DashboardAgendamiento from "../componentsdash/Modulos/Agendamiento/DashboardAgendamiento";
import DashboardHistoriaClinica from "../componentsdash/Modulos/Historia Clinica/DashboardHistoriaClinica";
import DashboardConfiguracion from "../componentsdash/Modulos/Configuracion/DashboardConfiguracion";
import AltaHistoriaClinica from "../componentsdash/Modulos/Historia Clinica/Altahistoriaclinica/AltaHistoriaClinica";
import ConsultaSeguimiento from "../componentsdash/Modulos/Historia Clinica/ConsultaSeguimiento/ConsultaSeguimiento"; 
import GestionPerfil from "../componentsdash/Modulos/Configuracion/Modulosconfiguracion/GestionPerfil";
import SeguridadCuenta from "../componentsdash/Modulos/Configuracion/Modulosconfiguracion/SeguridadCuenta";
import ConfigurarReceta from "../componentsdash/Modulos/Configuracion/Modulosconfiguracion/ConfigurarReceta";
import DashboardRecetas from "../componentsdash/Modulos/Recetas electronicas/DashboardRecetas";
import DashboardPaciente from "../componentsdash/Modulos/Historia Clinica/DashboardPaciente/DashboardPaciente";
import RecetaFormulario from "../componentsdash/Modulos/Recetas electronicas/RecetaFormulario";
import ConfiguracionPago from "../payments/ConfiguracionPago";
import Registro from "../componentsauth/Registro";
import Login from "../componentsauth/Login";
import RecuperarPassword from "../componentsauth/Recuperar";
import ConfirmarReset from "../componentsauth/ResetPassword";
import PrivateRoute from "../componentsauth/PrivateRoute";
import AltaPaciente from "../componentsdash/Modulos/Historia Clinica/AltaPaciente";
import Home from "../componentshome/Home";
import CentroAyuda from "../componentsdash/Modulos/CentrodeAyuda/CentroAyuda";
import BotonWhatsapp from "../componentshome/Botonwhatsapp";
import ConfigurarCuestionario from "../componentsdash/Modulos/Configuracion/Modulosconfiguracion/ConfigurarCuestionario";
import ValidarReceta from '../componentshome/Landings/ValidarReceta';
import FichaPrevia from "../componentshome/Landings/FichaPrevia";
import AgendaPublica from "../componentshome/Landings/AgendaPublica";
import AvisoPrivacidadPaciente from "../componentshome/Landings/AvisoPrivacidadPaciente";
import TerminosCondiciones from "../componentshome/Landings/TerminosCondiciones";
import AvisoPrivacidadSalvir from "../componentshome/Landings/AvisoPrivacidadSalvir";
import AuditoriaActividad from "../componentsdash/Modulos/Configuracion/Modulosconfiguracion/AuditoriaActividad";
import TableroFinanzas from "../componentsdash/Modulos/Finanzas/TableroFinanzas";
import paginas from "../utils/paginas.json";



const rutasPublicas = [
    "/registro",
    "/login",
    ...paginas.map((p) => p.ruta),
  ];

// 🔒 Este componente usa useLocation() y debe estar dentro del Router
const AppRoutesContent = () => {
  const location = useLocation();

 useEffect(() => {
  if (rutasPublicas.includes(location.pathname)) {
    // GA4
    sendPageView(location.pathname);

    // Meta
    sendMetaPageView(location.pathname);
  }
}, [location.pathname]);

  return (
      <>
      {/* ✅ Solo en rutas públicas muestra el botón */}
      {rutasPublicas.includes(location.pathname) && <BotonWhatsapp />}
    <Routes>
      <Route path="/" element={<Home />} />

      {/* 🔓 Públicas */}
      <Route path="/registro" element={<Registro />} />
      <Route path="/login" element={<Login />} />
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="/seguridad" element={<Home />} />
      <Route path="/preguntas-frecuentes" element={<Home />} />
      <Route path="/recuperar-password" element={<RecuperarPassword />} />
      <Route path="/recuperar-password/reset/confirm/:uid/:token" element={<ConfirmarReset />} />
      <Route path="/validar-receta/:id" element={<ValidarReceta />} />
      <Route path="/ficha/:token" element={<FichaPrevia />} />
      <Route path="/agendar/:bookingId" element={<AgendaPublica />} />
      <Route path="/aviso-privacidad/:tipo/:id" element={<AvisoPrivacidadPaciente />} />
      <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
      <Route path="/aviso-de-privacidad" element={<AvisoPrivacidadSalvir />} />

      {/* 🔐 Privadas */}
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard/alta-paciente" element={<AltaPaciente />} />
        <Route path="/dashboard" element={<Dashboard />}>
            {/* Rutas del Dashboard */}
          <Route path="inicio" element={<DashboardContent />} />
          <Route path="/dashboard/citas" element={<DashboardAgendamiento />} />
          <Route path="/dashboard/historias-clinicas" element={<DashboardHistoriaClinica />} />
          <Route path="/dashboard/recetas" element={<DashboardRecetas />} />
          <Route path="/dashboard/configuracion" element={<DashboardConfiguracion />} />
          <Route path="/dashboard/configuracion/perfil" element={<GestionPerfil />} />
          <Route path="/dashboard/configuracion/seguridad" element={<SeguridadCuenta />} />
          <Route path="/dashboard/configuracion/receta" element={<ConfigurarReceta />} />
          <Route path="/dashboard/configuracion/cuestionario" element={<ConfigurarCuestionario />} />
          <Route path="/dashboard/configuracion/auditoria" element={<AuditoriaActividad />}/>
          <Route path="/dashboard/alta-historia-clinica/:id" element={<AltaHistoriaClinica />} />
          <Route path="/dashboard/consulta-seguimiento/:id" element={<ConsultaSeguimiento />} />
          <Route path="/dashboard/paciente/:id" element={<DashboardPaciente />} />
          <Route path="/dashboard/recetas/formulario" element={<RecetaFormulario />} />
          <Route path="/dashboard/finanzas" element={<TableroFinanzas />} />
          <Route path="/dashboard/ayuda" element={<CentroAyuda />} />

          <Route
            path="/dashboard/configuracion/pago"
            element={
              <Elements stripe={stripePromise}>
                <ConfiguracionPago />
              </Elements>
            }
          />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/dashboard/inicio" />} />
    </Routes>
     </>
  );
};

// Este es el único <Router> (todo lo de arriba queda adentro)
const AppRoutes = () => {
  return (
    <Router>
      <AppRoutesContent />
    </Router>
  );
};

export default AppRoutes;
